import { compose } from 'recompose';

import SearchGroup from './searchGroup';

const enhance = compose();
export default enhance(SearchGroup);
